(() => {
  const dialog = document.getElementById('cb-privacy-dialog');
  if (!dialog) return;
  const launch = document.getElementById('cb-privacy-launch');
  const status = document.getElementById('cb-privacy-status');
  const retry = document.getElementById('cb-privacy-retry');
  const buttons = [...dialog.querySelectorAll('[data-cb-consent]')];
  const keys = ['preferences', 'analytics', 'marketing'];
  let api;
  let busy = false;
  let previousFocus;
  const sessionGet = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
  const sessionSet = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
  function open() {
    previousFocus = document.activeElement;
    if (api) {
      const consent = api.currentVisitorConsent();
      keys.forEach(key => { document.getElementById('cb-consent-' + key).checked = consent[key] === 'yes'; });
    }
    if (!dialog.open) dialog.showModal();
    window.clarissaPrivacyOpen = true;
  }
  function close() {
    dialog.close();
    window.clarissaPrivacyOpen = false;
    if (previousFocus && previousFocus.isConnected) previousFocus.focus();
    document.dispatchEvent(new CustomEvent('clarissa:privacy-closed'));
  }
  function fail() {
    api = undefined;
    status.textContent = status.dataset.error;
    retry.hidden = false;
    buttons.forEach(button => { button.disabled = true; });
  }
  function ready() {
    api = window.Shopify.customerPrivacy;
    if (!api) return fail();
    status.textContent = '';
    retry.hidden = true;
    buttons.forEach(button => { button.disabled = false; });
    const consent = api.currentVisitorConsent();
    keys.forEach(key => { document.getElementById('cb-consent-' + key).checked = consent[key] === 'yes'; });
  }
  function initialize(attempt = 0) {
    status.textContent = status.dataset.loading;
    retry.hidden = true;
    if (window.Shopify?.customerPrivacy) return ready();
    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => error ? fail() : ready());
    } else if (attempt < 20) {
      window.setTimeout(() => initialize(attempt + 1), 250);
    } else fail();
  }
  buttons.forEach(button => button.addEventListener('click', () => {
    if (!api || busy) return;
    const decision = button.dataset.cbConsent;
    const choices = Object.fromEntries(keys.map(key => [key, decision === 'save' ? document.getElementById('cb-consent-' + key).checked : decision === 'accept']));
    busy = true;
    buttons.forEach(item => { item.disabled = true; });
    status.textContent = status.dataset.saving;
    const timeout = window.setTimeout(() => { busy = false; fail(); }, 10000);
    try {
      api.setTrackingConsent(choices, () => {
        window.clearTimeout(timeout);
        busy = false;
        buttons.forEach(item => { item.disabled = false; });
        status.textContent = '';
        sessionSet('clarissaPrivacyDecided', '1');
        close();
      });
    } catch {
      window.clearTimeout(timeout);
      busy = false;
      fail();
    }
  }));
  launch.addEventListener('click', open);
  retry.addEventListener('click', () => initialize());
  document.getElementById('cb-privacy-close').addEventListener('click', () => { if (!busy) close(); });
  dialog.addEventListener('cancel', event => { event.preventDefault(); if (!busy) close(); });
  initialize();
  if (!sessionGet('clarissaPrivacyPresented')) {
    sessionSet('clarissaPrivacyPresented', '1');
    open();
  }
})();
